import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";

export const getEstadoPagoProveedores = async () => {
    const respuesta = PrivateInterceptorsPR(`Global/Status/EstadoPagoProveedores`, 'GET')
    return respuesta
}